<template>
  <select
    class="typography-subtitle-0 p-3 pr-8 mb-3 border border-primary h-11 rounded text-gray appearance-none w-full bg-[url(/assets/svg/rounded-triangle.svg)] bg-[length:1rem] bg-[calc(100%-0.75rem)_center]"
    :class="[
      '[&:is(.error)]:border-danger',
      '[&:is(.error)]:outline-danger',
      '[&:is(.error)]:shadow-none',
      '[&:is(.valid)]:border-success',
      '[&:is(.valid)]:outline-success',
      '[&:is(.valid)]:shadow-none',
      { error, valid }
    ]"
    v-model="model"
  >
    <option v-for="(label, value) in options" :key="value" :value="value ?? label">
      {{ label }}
    </option>
  </select>
</template>

<script lang="ts" setup>
defineProps<{
  options: Record<string, string>
  error?: boolean
  valid?: boolean
}>()

const model = defineModel<string>()
</script>
